import { EnableToasts } from 'modules/ToastManager';
import { AskForOpportunities } from 'pages/askForOpportunities';
import { lazy, memo } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ErrorBoundary, GlobalStyleConnector, Layout, LazyConnector } from 'shared/components';
import { APP_ROUTES } from 'shared/constants';

import RouteGuard from './RouteGuard';

const CandidateAvailability = lazy(async () => import('../pages/candidateAvailability/ui/CandidateAvailability'));
const CandidateOfferListPage = lazy(async () => import('../pages/candidateOfferList'));
const CandidateOfferRoutes = lazy(async () => import('../pages/candidateOffer'));
const AIAssistant = lazy(async () => import('../features/ai-assistant').then(m => ({ default: m.AIAssistant })));
const ProfileViewPage = lazy(async () => import('../pages/profile').then(m => ({ default: m.ProfileViewPage })));
const ProfileEditPage = lazy(async () => import('../pages/profile').then(m => ({ default: m.ProfileEditPage })));
const MyJobsPage = lazy(async () => import('../pages/myJobs').then(m => ({ default: m.MyJobsPage })));
const JobDetailsPage = lazy(async () => import('../pages/myJobs').then(m => ({ default: m.JobDetailsPage })));
const JobPreferencesPage = lazy(async () => import('../pages/jobPreferences').then(m => ({ default: m.JobPreferencesViewPage })));
const JobPreferencesEditPage = lazy(async () => import('../pages/jobPreferences').then(m => ({ default: m.JobPreferencesEditPage })));
const ContactsPage = lazy(async () => import('../features/contacts').then(m => ({ default: m.ContactsPage })));

function AppRoutes() {
    return (
        <Routes>
            <Route element={ <GlobalStyleConnector /> }>
                <Route element={ <EnableToasts /> }>
                    <Route element={ <RouteGuard /> }>
                        <Route element={ <Layout /> }>
                            <Route path={ APP_ROUTES.candidateAvailability('*') }
                                element={ (
                                    <ErrorBoundary>
                                        <LazyConnector>
                                            <CandidateAvailability />
                                        </LazyConnector>
                                    </ErrorBoundary>
                                ) }
                            />

                            <Route path={ APP_ROUTES.candidateOffers }>
                                <Route path=":orderId/:orderRoleId/*"
                                    element={ (
                                        <LazyConnector>
                                            <CandidateOfferRoutes />
                                        </LazyConnector>
                                    ) }
                                />

                                <Route index
                                    element={ (
                                        <ErrorBoundary>
                                            <LazyConnector>
                                                <CandidateOfferListPage />
                                            </LazyConnector>
                                        </ErrorBoundary>
                                    ) }
                                />
                            </Route>
                        
                            <Route path={ APP_ROUTES.preferences }
                                element={ (
                                    <ErrorBoundary>
                                        <LazyConnector>
                                            <JobPreferencesPage />
                                        </LazyConnector>
                                    </ErrorBoundary>
                                ) }
                            />

                            <Route path={ APP_ROUTES.preferencesEdit }
                                element={ (
                                    <ErrorBoundary>
                                        <LazyConnector>
                                            <JobPreferencesEditPage />
                                        </LazyConnector>
                                    </ErrorBoundary>
                                ) }
                            />

                            <Route path={ APP_ROUTES.aiAssistant }
                                element={ (
                                    <ErrorBoundary>
                                        <LazyConnector>
                                            <AIAssistant />
                                        </LazyConnector>
                                    </ErrorBoundary>
                                ) }
                            />
                            
                            <Route path={ APP_ROUTES.profile }
                                element={ (
                                    <ErrorBoundary>
                                        <LazyConnector>
                                            <ProfileViewPage />
                                        </LazyConnector>
                                    </ErrorBoundary>
                                ) }
                            />

                            <Route path={ APP_ROUTES.profileEdit }
                                element={ (
                                    <ErrorBoundary>
                                        <LazyConnector>
                                            <ProfileEditPage />
                                        </LazyConnector>
                                    </ErrorBoundary>
                                ) }
                            />

                            <Route path={ APP_ROUTES.requestForOpportunities }
                                element={ (
                                    <ErrorBoundary>
                                        <LazyConnector>
                                            <AskForOpportunities />
                                        </LazyConnector>
                                    </ErrorBoundary>
                                ) }
                            />

                            <Route path={ APP_ROUTES.myJobs }>
                                <Route path=":id"
                                    element={ (
                                        <ErrorBoundary>
                                            <LazyConnector>
                                                <JobDetailsPage />
                                            </LazyConnector>
                                        </ErrorBoundary>
                                    ) }
                                />

                                <Route index
                                    element={ (
                                        <ErrorBoundary>
                                            <LazyConnector>
                                                <MyJobsPage />
                                            </LazyConnector>
                                        </ErrorBoundary>
                                    ) }
                                />
                            </Route>

                            <Route path={ APP_ROUTES.contacts }
                                element={ (
                                    <ErrorBoundary>
                                        <LazyConnector>
                                            <ContactsPage />
                                        </LazyConnector>
                                    </ErrorBoundary>
                                ) }
                            />
                        </Route>

                        <Route
                            path="*"
                            element={ <Navigate to={ APP_ROUTES.candidateOffers }
                                replace /> }
                        />
                    </Route>
                </Route>
            </Route>
        </Routes>
    );
}

export default memo(AppRoutes);
